import { VolumeOffOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useContext } from "react";

import ContextualFooter from "@/components/ContextualFooter";
import SessionRecorderFooter from "@/components/SessionRecorderFooter/Index";
import { useReactiveSelectQuery } from "@/models/hooks/useReactiveSelectQuery.ts";
import { fetchFeedCommandAliasesQuery } from "@/models/repositories";
import { CurrentFeedContext } from "@/models/StateProviders/currentFeedProvider";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider";
import { UxContext } from "@/models/UxStateProvider";

export default function FeedFooter() {
  const { userReadOnlyMode } = useContext(UxContext);
  const { currentFeed, haveWritePermission } = useContext(CurrentFeedContext);
  const { currentWorkspaceId } = useContext(WorkspaceContext);
  const canRecordOrUpload = haveWritePermission;
  const isSilentChannel = currentFeed?.isSilent;

  const commandAliases =
    useReactiveSelectQuery(
      fetchFeedCommandAliasesQuery,
      [currentFeed?.id],
      "FeedFooter:fetchFeedCommandAliasesQuery",
    ) ?? [];
  const commandAlias = commandAliases?.[0];

  if (canRecordOrUpload && !userReadOnlyMode) {
    return (
      <SessionRecorderFooter
        workspaceId={currentWorkspaceId}
        feedId={currentFeed?.id}
        aliasOwnerAccountId={commandAlias?.id}
      />
    );
  }

  return (
    <ContextualFooter sx={{ height: isSilentChannel ? 64 : 34 }}>
      {userReadOnlyMode ? "You are in Read Only mode" : "You are a listener in this channel"}
      {isSilentChannel ? (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <VolumeOffOutlined role="presentation" sx={{ pr: 0.5 }} />
          <Typography sx={{ fontSize: "12px", fontStyle: "italic", fontWeight: 500 }}>Hands-free is off</Typography>
        </Box>
      ) : null}
    </ContextualFooter>
  );
}
